import NiceModal from '@ebay/nice-modal-react';

import Button from 'components/field/Button';

import ImportDataModal from 'modals/ImportDataModal';

const ImportByTemplate = ({ setValue, importActionDetails }) => {
	const { icon, title, acceptedFileTypes, downloadUrl, uploadUrl } = importActionDetails;

	const handleModalTrigger = () => {
		NiceModal.show(ImportDataModal, {
			title,
			acceptedFileTypes,
			icon,
			downloadUrl,
			uploadUrl,
			setTableData: (value) => {
				setValue('tableData', value, {
					shouldValidate: true,
					shouldDirty: true
				});
			}
		});
	};
	return <Button onClick={() => handleModalTrigger()} variant="black" size="large" icon={icon} label={title} />;
};

export default ImportByTemplate;
